import { consumerTheme, fontWeights, spacing, colors as syfColors, fontSizes as syfFontSizes } from 'syf-component-library/defaultTheme';
const colors = Object.assign(Object.assign({}, syfColors), { trueBlack: '#000000' });
const fontSizes = Object.assign({ regular: 14 }, syfFontSizes);
export { colors, fontSizes, fontWeights, spacing };
export default consumerTheme;
//# sourceMappingURL=theme.js.map